import GridDiscounts from '../components/landings/GridDiscounts/GridDiscounts';
import Paragraph from '../components/landings/Paragraph/paragraph.jsx';
import Banner from '../components/landings/Banner/banner.jsx';

const Landings = () => {
  return (
    <main className="Landings">     
     <Banner />
     <Paragraph />
     <GridDiscounts />     
    </main>
  );
}

export default Landings;